import { createSelector } from 'reselect';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { StepOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenario } from 'entities/scenario';

export const selectEarlyRepaymentPopup = createSelector(getScenario, (content) => {
  return (content as StepOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>)?.interactions?.earlyRepayment?.action?.modalContent;
});

export const selectOfferDocumentsInfoPopup = createSelector(getScenario, (content) => {
  return (content as StepOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>)?.interactions?.offerDocumentsInfo?.action
    ?.modalContent;
});

export const selectPostIssuanceHelp = createSelector(
  getScenario,
  selectEarlyRepaymentPopup,
  selectOfferDocumentsInfoPopup,
  (content, earlyRepaymentPopup) => {
    return {
      helps: (content as StepOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>)?.content.postIssuanceHelp || [],
      isAvailableEarlyRepaymentPopup: Boolean(earlyRepaymentPopup),
      isAvailableOfferDocumentsInfoPopup: Boolean(earlyRepaymentPopup),
    };
  },
);
